import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function DocumentsIcon({ className }: IconProps) {
  return (
    <svg
      width="80"
      height="81"
      viewBox="0 0 80 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_4_3392)">
        <path
          d="M70.7879 80.2424V3.63636C70.7879 1.69697 69.0909 0 67.1515 0H3.63636C1.69697 0 0 1.69697 0 3.63636V70.303C0 75.6364 4.36364 80 9.69697 80H70.7879V80.2424Z"
          fill="#EAEEF9"
        />
        <path
          d="M9.93945 80.2424C14.5455 80.2424 18.4243 76.8485 19.1516 72.2424C19.1516 71.5152 19.8788 71.0303 20.6061 71.0303H78.5455C79.5152 71.0303 80.2425 71.7576 80.0001 72.7273C79.2728 77.0909 75.394 80.2424 70.7879 80.2424H9.93945Z"
          fill="#00C4B3"
        />
        <path
          d="M61.0913 36.1212C61.0913 29.5758 58.4246 23.5152 53.8185 18.9091C49.2125 14.303 42.9094 11.6364 36.364 11.6364C29.8185 11.6364 23.5155 14.303 18.9094 18.9091C14.3034 23.5152 11.6367 29.8182 11.6367 36.3636C11.6367 42.9091 14.3034 48.9697 18.9094 53.8182C23.5155 58.4243 29.3337 60.8485 35.8791 61.0909H36.364C42.9094 61.0909 49.2125 58.4243 53.8185 53.8182L54.5458 53.0909L50.9094 49.2121L50.1822 49.9394C46.5458 53.5758 41.6973 55.5152 36.6064 55.5152C31.5155 55.5152 26.667 53.5758 23.0307 49.9394C19.3943 46.303 17.4549 41.4545 17.4549 36.3636C17.4549 31.2727 19.3943 26.4242 23.0307 22.7879C26.667 19.1515 31.5155 17.2121 36.6064 17.2121C41.6973 17.2121 46.5458 19.1515 50.1822 22.7879C53.0913 25.697 55.0307 29.5758 55.5155 33.697H51.6367H51.3943C50.9094 30.5455 49.4549 27.8788 47.2731 25.697C44.364 22.7879 40.4852 21.3333 36.364 21.3333C32.2428 21.3333 28.364 23.0303 25.4549 25.697C22.5458 28.6061 21.0913 32.4849 21.0913 36.6061C21.0913 40.7273 22.7882 44.6061 25.4549 47.2727C28.364 50.1818 32.0004 51.6364 35.8791 51.6364H36.1216C40.2428 51.6364 44.1216 49.9394 47.0307 47.2727L47.7579 46.5455L43.8791 42.6667L43.1519 43.3939C41.2125 45.3333 38.7882 46.303 36.1216 46.303C33.4549 46.303 31.0307 45.3333 29.0913 43.3939C27.8791 42.1818 26.9094 40.7273 26.667 39.0303H33.4549H36.1216H46.061H51.3943H60.6064L61.0913 36.1212C61.0913 36.3636 61.0913 36.3636 61.0913 36.1212ZM36.6064 33.9394H33.9397H27.1519C27.6367 32.2424 28.364 30.7879 29.5761 29.5758C31.5155 27.6364 33.9397 26.6667 36.6064 26.6667C39.2731 26.6667 41.6973 27.6364 43.6367 29.5758C44.8488 30.7879 45.8185 32.2424 46.061 33.9394H36.6064Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_3392">
          <rect width="80" height="80.2424" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
